import { AssessmentsSection } from "@app/assessments/components/AssessmentsSection";
import type { Assessment } from "@core/assessments/types";
import { trans } from "@mongez/localization";
import { Link } from "@remix-run/react";
import { ClipboardCheck, Sparkles } from "lucide-react";

export function ModernHomeAssessments({
  assessments = [],
}: {
  assessments?: Assessment[];
}) {
  if (assessments.length === 0) return null;

  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-indigo-100 bg-gradient-to-br from-indigo-50 via-white to-fuchsia-50 p-5 dark:border-indigo-950 dark:from-indigo-950/30 dark:via-slate-950 dark:to-fuchsia-950/20 sm:p-7">
      <Sparkles className="absolute -end-8 -top-8 h-40 w-40 text-indigo-200/30 dark:text-indigo-800/15" />
      <div className="relative mb-6 flex items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-600 text-white shadow-lg shadow-indigo-600/20">
            <ClipboardCheck className="h-5 w-5" />
          </span>
          <div>
            <p className="text-xs font-black text-indigo-600 dark:text-indigo-300">
              {trans("home.challengeYourself")}
            </p>
            <h2 className="text-xl font-black text-slate-950 dark:text-white">
              {trans("home.latestAssessments")}
            </h2>
          </div>
        </div>
        <Link
          to="/assessments"
          className="text-sm font-black text-indigo-700 dark:text-indigo-300">
          {trans("home.viewAll")}
        </Link>
      </div>
      <div className="relative">
        <AssessmentsSection assessments={assessments.slice(0, 3)} />
      </div>
    </section>
  );
}
